import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { QuickTodoPanelComponent } from './quick-todo-panel.component';
import { ComponentsModule } from 'app/components/components.module';
import { CreateEditTaskModule } from 'app/main/pm/crm/shared/tasks/create-edit-task/create-edit-task.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [QuickTodoPanelComponent],
    exports: [QuickTodoPanelComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        TranslateModule,
        ComponentsModule,
        CreateEditTaskModule,
    ],
})
export class QuickTodoPanelModule {}
